export default __webpack_public_path__ + "static/media/wildlife_conservation_network.11573cea.svg";